// HOOKS
import { useState, useEffect } from "react";

const useDebouncedSearch = (delay) => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, delay]);
  return { inputValue, setInputValue, debouncedValue, setDebouncedValue };
};

export default useDebouncedSearch;
